<div class="container-fluid p-5 pt-3" style="min-height: calc(100vh - 57px) !important">
    <div class="row">
        <div class="col-12 ps-5">
            <div aria-label="breadcrumb" class="text-right float-right">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-grey" href="/home">HOME</a></li>
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-grey" href="/process-list">Centralización Remuneraciones</a></li>
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-blue">Mantenedor de Centros</a></li>
                </ol>
            </div>
        </div>
        <div class="col-12 ps-5">
            <p class="fzas-titulo-componente">Mantenedor de Centros</p>
        </div>
        <div class="col-12">
            <div class="container card-container">
                <div class="row">
                    <div class="col px-4 pt-3">
                        <div class="card fzas-card-filtros">
                            <div class="card-body px-4">
                                <form [formGroup]="filtrosForm" class="row">
                                    <div class="col-12">
                                        <p class="fzas-title-filtros">Buscar Centro</p>
                                    </div>
                                    <div class="col-12 col-md-12 col-xl-6">
                                        <label for="centNombreCentro" class="form-label fzas-text-input">Nombre Centro</label>
                                        <input type="text" formControlName="centNombreCentro" name="centNombreCentro" placeholder="Escribe el nombre del centro" class="form-control" (input)="validarAlfanumerico($event)"/>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="centId" class="form-label fzas-text-input">ID Centro</label>
                                        <input type="text" formControlName="centId" name="centId" placeholder="Escribe el ID del centro" class="form-control"/>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="centActivado" name="centActivado"class="form-label fzas-text-input">Estado</label>
                                        <select formControlName="centActivado" class="form-control fzas-custom-select">
                                            <option [ngValue]="null">Seleccione Estado</option>
                                            <option [ngValue]="1">Activo</option>
                                            <option [ngValue]="0">Inactivo</option>
                                        </select>
                                    </div>
                                    <div class="col-12 mt-4 d-flex justify-content-end gap-3">
                                        <button type="button" class="btn btn-cancelar-accion" (click)="limpiarFiltros()">Limpiar Filtros</button>
                                        <button type="button" class="btn btn-aplicar-accion"(click)="aplicarFiltros()">Aplicar Filtros</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-4 pt-4 d-flex justify-content-end gap-3">
                        <button type="button" class="btn btn-aplicar-accion" (click)="abrirModalCrearCentro()">Crear Nuevo Centro
                            <img src="./assets/icon/mas.svg" alt="" class="ms-2">
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-4 pt-4">
                        <table mat-table [dataSource]="dataSource" multiTemplateDataRows style="width: 100%">
    
                            <ng-container matColumnDef="centId">
                                <th mat-header-cell *matHeaderCellDef  style="text-align: center !important; min-width: 100px !important;">ID Centro</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 190px !important;">{{ element.centCodigoCompania }}</td>
                            </ng-container>
    
                            <ng-container matColumnDef="centNombreCentro">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Nombre
                                    <img src="./assets/icon/flecha-sort.svg" alt="" width="14px" class="mb-1 rotar">
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 200px !important;">{{ element.centNombreCentro }}</td>
                            </ng-container>
                            <ng-container matColumnDef="centSociedad">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Sociedad</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 120px !important;">{{ element.centSociedad }}</td>
                            </ng-container>
                            <ng-container matColumnDef="centSegmento">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Segmento</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 120px !important;">{{ element.centSegmento }}</td>
                            </ng-container>
    
                            <ng-container matColumnDef="centAnalistaFinanzas">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Analista Finanzas</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 200px !important;">{{ element.centAnalistaFinanzas }}</td>
                            </ng-container>

                            

                            <!-- <ng-container matColumnDef="centCentroCosto">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Centro de Costo</th>
                                <td mat-cell *matCellDef="let element" style="text-align: center !important; max-width: 170px !important;">{{ element.centCentroCosto }}</td>
                            </ng-container> -->

                            
    
                            <ng-container matColumnDef="centActivado">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Estado</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <ng-container *ngIf="element.centActivado">
                                        <span class="fzas-badge-activo">Activo</span>
                                    </ng-container>
                                    <ng-container *ngIf="!element.centActivado">
                                        <span class="fzas-badge-inactivo">Inactivo</span>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="centroOpciones">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center !important;">Opciones</th>
                                <td mat-cell *matCellDef="let element" class="text-center">
                                    <div ngbDropdown container="body">
                                        <button type="button" class="btn border-0 btn-opciones" id="dropdownBasic1" ngbDropdownToggle>
                                            <img src="./assets/icon/opciones-grid.svg">
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="p-0">
                                            <button class="w-100 py-2 d-flex align-items-center" ngbDropdownItem (click)="abrirModalEditarCentro(element)">
                                                <img src="./assets/icon/editar.svg" alt="" width="18px" class="me-2">
                                                <span class="fzas-text-dropdownmenu">
                                                    Editar
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
    
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell py-3 text-center" [attr.colspan]="displayedColumns.length">No hay centros registrados.</td>
                            </tr>
                        </table>
                        <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" ></mat-paginator>
                    </div>
                    <div class="col-12">
                        <div class="container">
                            <div class="row">
                                <div class="col-12 px-4 pt-4 d-flex justify-content-end gap-3">
                                    <button type="button" class="btn btn-aplicar-accion" (click)="cancelar()">Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</div>